// src/components/navigation/index.js
import { connect } from 'react-redux'
import { 
  getNavigationMenuList, 
  getNavigationBackList, 
  getNavigationActive,
  getNavigationOverArtists,
  getNavigationBackPathname,
  getHideArtists } from './selectors'
import {
  getTransitionActive,
  getCurrentPageName
} from '../app/selectors'

import Navigation from './navigation'

const mapStateToProps = state => {
  return {
    transitionActive: getTransitionActive(state),
    pageName: getCurrentPageName(state),
    overArtists: getNavigationOverArtists(state),
    hideArtists: getHideArtists(state),
    active: getNavigationActive(state),
    menu: getNavigationMenuList(state),
    back: getNavigationBackList(state),
    backPathname: getNavigationBackPathname(state)
  }
}

export default connect(mapStateToProps, null)(Navigation)



// WEBPACK FOOTER //
// ./src/components/navigation/index.js